
import { defineComponent, PropType } from 'vue';
import { camelCase } from 'lodash';
import BuilderGallery from './Gallery/index.vue';
import BuilderQuotes from './Quotes/index.vue';
import BuilderPushContent from './PushContent/index.vue';
import BuilderText from './Text/index.vue';
// import mocQuotes from './Quotes/moc.json';

const PageBuilder = defineComponent({
  name: 'PageBuilder',
  components: {
    BuilderGallery,
    BuilderQuotes,
    BuilderPushContent,
    BuilderText
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    components: {
      type: Array as PropType<BuilderComponent[]>,
      default() { return []; },
    },
    debug: {
      type: Boolean,
      default: false,
    },
  },
  setup(){
    /**
     * @returns {String} the correct component name (or null)
     */

    function getComponent(item: {component: string}) {
      const name = camelCase(`Builder_${item.component.replace('component_', '')}`);
      return name;
    }

    return {
      getComponent: getComponent,
      // mocQuotes,
    }
  
  },
});
export default PageBuilder

